import { createRouter, createWebHistory } from "vue-router";

const router = createRouter({
  history: createWebHistory(),
  mode: "history",
  routes: [
    {
      path: "/vbcxbea", // 隐私协议
      name: "vbcxbea",
      meta: {
        title: "Perjanjian privasi",
      },
      component: () => import("@/views/vbcxbea/index.vue"),
    },
    {
      path: "/cijieq", // 手动打开push权限
      name: "cijieq",
      meta: {
        title: "Guía de activación",
      },
      component: () => import("@/views/cijieq/index.vue"),
    },
    {
      path: "/sidjxb", // 设置权限方法，说明页面
      name: "sidjxb",
      meta: {
        title: "Tentang kami",
      },
      component: () => import("@/views/sidjxb/index.vue"),
    },
    {
      path: "/afckvvfy", // IM
      name: "afckvvfy",
      component: () => import("@/views/afckvvfy/index.vue"),
    },
    // {
    //   path: "/yivcxn", // 投诉
    //   name: "Yivcxn",
    //   meta: {
    //     title: "Komplain",
    //   },
    //   component: () => import("@/views/yivcxn/index.vue"),
    // },
    {
      path: "/ewrewfds", // 下载
      name: "ewrewfds",
      component: () => import("@/views/ewrewfds/index.vue"),
    },
  ],
});

export default router;
